// Sdílené popisky a styly stavů cest.
export const TRIP_STATUS = {
  planned: 'Naplánováno',
  en_route: 'Na cestě',
  arrived: 'Na místě',
  completed: 'Dokončeno',
  cancelled: 'Zrušeno',
};

// Mapování stavu → CSS badge třída (z index.css).
export const TRIP_STATUS_BADGE = {
  planned: 'badge-none',
  en_route: 'badge-in',
  arrived: 'badge-active',
  completed: 'badge-out',
  cancelled: 'badge-inactive',
};

export const HANDOVER_MODES = {
  manual: 'Ruční potvrzení',
  qr: 'QR checkpointy',
};

// Popisek umístění nákladu v rámci jednotky konvoje.
export const PLACEMENT_LABELS = { vehicle: 'Vozidlo', trailer: 'Vlek' };

// Možné následující stavy z aktuálního stavu (jednoduchý workflow).
export const NEXT_STATUSES = {
  planned: ['en_route', 'cancelled'],
  en_route: ['arrived', 'cancelled'],
  arrived: ['completed', 'en_route'],
  completed: [],
  cancelled: ['planned'],
};

export function fuelLabel(v) {
  if (v == null) return '';
  return `${v} %`;
}
